import { methods, ServiceMaker } from "./index";

const { POST, GET } = methods;

export const createRequest = async (data) => {
  const result = await ServiceMaker(
    "/v1/api/pg/order/request",
    POST,
    null,
    data
  );
  console.log("got result : ", result);
  const {
    response: { redirect: REDIRECT_URL, parameters },
  } = result;
  return {
    REDIRECT_URL,
    parameters,
  };
};

export const createEasyBuzzRequest = async (data) => {
  const results = await ServiceMaker(
    "/v1/api/payments/easebuzz/request",
    POST,
    null,
    data
  );
  console.log("got result : ", results);
  return results;
};

export const createRequestQuickPay = async (data) => {
  const result = await ServiceMaker(
    "/v1/api/pg/order/request/quickpay",
    POST,
    null,
    data
  );
  console.log("got result : ", result);
  const {
    response: { redirect: REDIRECT_URL, parameters },
  } = result;
  return {
    REDIRECT_URL,
    parameters,
  };
};

export const getStatus = async (id) =>
  ServiceMaker(`/v1/api/pg/order/status/${id}`, GET);

export const getCount = async () =>
  ServiceMaker(`/v1/api/gatewaytype/getcount`, GET);

export const getCustomerData = async (id) =>
  ServiceMaker(`/v1/api/customer/info/${id}`, GET);

export const getCustomerDataBySerialNo = async (id) =>
  ServiceMaker(`/v1/api/customer/infoBySerialNo/${id}`, GET);
